import { render } from "./VSCodeHotkeys.vue?vue&type=template&id=0281047c&scoped=true&ts=true"
import script from "./VSCodeHotkeys.vue?vue&type=script&lang=ts"
export * from "./VSCodeHotkeys.vue?vue&type=script&lang=ts"

import "./VSCodeHotkeys.vue?vue&type=style&index=0&id=0281047c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0281047c"]])

export default __exports__